import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SpinnerComponent } from '@custom-components/general/spinner/spinner.component';
import { environment } from '@root/environments/environment';

@Component({
  selector: 'xemex-authorization-container',
  imports: [SpinnerComponent, TranslateModule],
  templateUrl: './authorization-container.component.html',
  styleUrl: './authorization-container.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class AuthorizationContainerComponent {
  isLoading = input<boolean>(false);
  isShowLogo = input<boolean>(true);

  readonly companyName = environment.branding.text.company.name;
  readonly currentYear = new Date().getFullYear();
}
